import axios from 'axios';
import { baseUrl_SPB } from '../BaseUrl';

const AddBookedItemListRoster = async (bookedItem,token) => {
    console.log('zul'+token);
    let modifiedItems= bookedItem.map(item => {
        // Ensure each item has a unique ID
      
        // Convert dd-mm-YYYY date to lexicographically sortable format (YYYY-mm-dd)
        if (item.date) {
            const parts = item.date.split('-');
            if (parts.length === 3) {
            // Pad month and day to 2 digits
            const day = parts[0].padStart(2, '0');
            const month = parts[1].padStart(2, '0');
            const year = parts[2];
            item.lexiDate = `${year}-${month}-${day}`;
            }
        }
        return item;
    });
    console.log('zul'+token);
    try {
        return new Promise((resolve, reject) => {
        console.log('i am zul');
        const response= axios.post(`${baseUrl_SPB}/api/v1/rostertimeallocation/savelist`, modifiedItems, {
            headers: {
                
                'Authorization': 'Bearer ' + token
            },
        }
        )
         .then(data => {
            
                return resolve(data);
            })
            .catch(error => {
                return reject('failed to add ',error);
            });
        });
        
       
    } catch (error) {
        console.error('Error updating user:', error);
        return null;
    }
}


export default AddBookedItemListRoster;;